import Swiper from 'swiper';

export const herbFinder = () => {
  document.addEventListener('DOMContentLoaded', function () {
    // eslint-disable-next-line no-unused-vars
    let herbFinderSwiper = new Swiper('.herb-finder__instructionContainer', {
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        375: {
          slidesPerView: 1.56,
          spaceBetween: 16,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        700: {
          slidesPerView: 2.5,
          spaceBetween: 32,
        },
        800: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        afterInit: function () {
          let herbWrappers = document.querySelectorAll('.herb-finder__wrapper');
          herbWrappers?.forEach((herbWrapper) => {
            herbWrapper?.classList.remove('gap-4', 'md:gap-8');
          });
        },
      },
    });
  });
};
